export default "__VITE_ASSET__ecd63816__"